import { render, staticRenderFns } from "./clubs.vue?vue&type=template&id=500317b2"
import script from "./clubs.vue?vue&type=script&lang=js"
export * from "./clubs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports